/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './addRule.defs.js'
export * as $defs from './addRule.defs.js'
